import { CHANGE_NAVIGATION_THEME, CHANGE_VISIBLE_ACCOUNT_LINKS } from '../actions/index';

const initialState = {
  darkTheme: false,
  isVisibleAccountLinks: true
};

const topNavigationStyles = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_NAVIGATION_THEME:
      return {
        ...state,
        darkTheme: action.darkTheme
      };
    case CHANGE_VISIBLE_ACCOUNT_LINKS:
      return {
        ...state,
        isVisibleAccountLinks: action.isVisibleAccountLinks
      };
    default:
      return state;
  }
};

export default topNavigationStyles;